import React from "react";
import { Link } from "react-router-dom";
import "../service.css";

export const Sustainability = () => {
  return (
    <div>
      <div className="tj-inner-banner">
        <div className="container">
          <h2>Sustainability</h2>
        </div>
      </div>

      <div className="tj-breadcrumb">
        <div className="container">
          <ul className="breadcrumb-list">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li className="active">Sustainability</li>
          </ul>
        </div>
      </div>
      <div className="container" style={{ paddingTop: "90px" }}>
        <div style={{ padding: "30px", display: "flex" }}></div>

        <h1 className="farex-h1" style={{ textAlign: "center" }}>
          Sustainability at Farex
        </h1>

        <img
          src="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/20px/s3/2024-07/farexbus-maxthrelfallphoto-13-landscape-sustainability.jpg"
          className="basic-page-header-image basic-page-paragraph-container"
          alt=""
          data-lazyload="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/header_image_basic_page_0_5x/s3/2024-07/farexbus-maxthrelfallphoto-13-landscape-sustainability.jpg 390w, https://cdn-cf.cms.farexbus.com/drupal-assets/styles/header_image_basic_page/s3/2024-07/farexbus-maxthrelfallphoto-13-landscape-sustainability.jpg 780w, https://cdn-cf.cms.farexbus.com/drupal-assets/styles/header_image_basic_page_1_5x/s3/2024-07/farexbus-maxthrelfallphoto-13-landscape-sustainability.jpg 1170w"
          sizes="100vw"
        />

        {/*        <div id="section-43649" style={{ clear: "both" }}>
          <div className="basic-page-paragraph-container">
            <a
              href="https://content.presspage.com/uploads/2327/2b6fa6e7-a753-4cb7-9f37-a3eca6bab5f6/farex-esg-report-2023-mobile.pdf?10000="
              type="button"
              className="farex-btn farex-btn--has-icon farex-btn--secondary"
            >
              <farex-icon
                name="document"
                size="4"
                aria-hidden="true"
              ></farex-icon>
              <span className="farex-btn__text">Download full ESG Report 2023</span>
            </a>
          </div>
        </div> */}

        <div id="section-43650" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h2>Our sustainability vision</h2>
            <p>&nbsp;</p>
            <p>
              <em>
                “We drive sustainable and affordable travel for everyone.”
              </em>
            </p>
            <p>
              <br />
              Sustainability is an <strong>
                integral part of our DNA
              </strong>{" "}
              since we brought our first cars on the road. We are driven by our
              purpose more than ever to drive{" "}
              <strong>
                sustainable and affordable travel for everyone to experience the
                world
              </strong>
              . At Farex, our sustainability state of mind is to achieve a good
              balance between <strong>ecology, economy and society</strong> as
              well as to create shared values for our stakeholders. We commit to
              driving{" "}
              <strong>safe and sustainable mobility for generations</strong>,
              safeguarding <strong>high business ethics and integrity</strong>,
              and contributing{" "}
              <strong>
                positive impact on our planet, people and society as a whole
              </strong>
              .
            </p>
            <p>
              Our sustainability strategy is based on the{" "}
              <strong>
                environmental, social and governance (ESG) framework
              </strong>
              . Here we defined our <strong>main strategic pillars</strong> as{" "}
              <strong>Planet, People, Travel</strong> as well as the foundation
              of these – our <strong>Governance</strong>.
            </p>
          </div>
        </div>

        <div id="section-43652" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h3>Protecting the Planet</h3>
            <p>
              As a global travel tech provider of affordable, accessible and
              intermodal travel, Farex holds a central responsibility to protect
              the planet and lead by example. Together with our partners, we set
              high environmental standards and push the boundaries for
              alternative mobility technologies, while providing already today
              more sustainable collective alternatives to the individual private
              car.
            </p>
            <p>
              Only by choosing Farexrvices, passengers could avoid 1.1 million
              tonnes of CO2 in 2023 alone.
            </p>
          </div>
        </div>

        <div id="section-43657" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h4>Our mission</h4>
            <ul>
              <li>Ensure high environmental standards for the Farex fleets.</li>
              <li>
                Enhance the implementation of sustainable travel through
                alternative drive and fuel technologies.
              </li>
              <li>
                Improve energy efficiency in operations by adopting sustainable
                practices in offices, procurement, and travel policies.
              </li>
            </ul>
          </div>
        </div>

        <div id="section-43658" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h3>Caring for People</h3>
            <p>
              In collective transport, safety is essential for all - our
              customers and drivers. Moreover, one of the great
              challenges of our time is to promote an equal, diverse and
              inclusive society. Together with our partners throughout the value
              chain, we are raising the bar of road safety and social standards
              in the mobility sector to{" "}
              <strong>
                create a safe, equal, diverse and inclusive environment in the
                workplace and wider society
              </strong>
              .&nbsp;
            </p>
            <h4>Our mission</h4>
            <ul>
              <li>
                Put safety of customers and drivers first. More about
                the <Link to={"/safety-onboard"}>safety in our cars here</Link>
                .
              </li>
              <li>
                Ensure fair compensation and decent working conditions for
                customers and drivers.
              </li>
              <li>
                Embrace diversity, equality and inclusion (DEI) in our company
                culture and values.
              </li>
              <li>
                Be a responsible corporate citizen and create positive social
                impact through strategic NGO partnerships.
              </li>
            </ul>
          </div>
        </div>

        <div id="section-43660" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h3>Enabling Travel</h3>
            <p>
              Travel is at an important turning point focusing on several
              aspects. While climate protection measures pay off for the future,
              our commitment of connecting people around the world with
              affordable and accessible travel enhances our customers’ daily
              lives. Together with our partners, we are shaping the future of
              the sector through innovation and partnerships across the
              industry.
            </p>
            <h4>Our mission</h4>
            <ul>
              <li>
                Provide affordable, accessible and intermodal travel options to
                connect communities and regions.
              </li>
              <li>
                Pursue the objective of carbon neutrality, testing multiple
                solutions to already reduce our environmental impact while
                zero-emission technologies for the long distance are lacking.
              </li>
              <li>
                Build multi-stakeholder partnerships to scale up alternative
                drive and fuel technologies in our partners fleet and transform
                the long distance coach market
              </li>
            </ul>
          </div>
        </div>

        <div id="section-43662" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h3>Strong Governance as foundation</h3>
            <p>
              Leading by example is our basic virtue. Therefore, we see{" "}
              <strong>
                strong governance at Farex and across the value chain as the
                foundation
              </strong>{" "}
              of our three strategic pillars People, Planet, and Travel. We
              established a Sustainability Steering Committee on Board level as
              the oversight body on sustainability performance. The committee is
              chaired by the CEO with senior leadership taking roles of business
              ambassadors across departments, which ensures the integration of
              sustainability goals and actions into business practices. Multiple
              governance and business ethics policies are established, for
              instance, data protection, employee Code of Conduct, Code of
              Conduct for business partners.&nbsp;
            </p>
            <h4>Our mission</h4>
            <ul>
              <li>
                Comply with high business ethics standards and regulatory
                requirements.
              </li>
              <li>Uphold of international human rights and labor laws.</li>
              <li>
                Strengthen responsible value chain management and integrate high
                environmental and social standards.
              </li>
              <li>Safeguard cybersecurity and data protection.</li>
            </ul>
            <h4>Double-materiality matrix</h4>
            <p>
              In line with the GRI framework, we conducted a double-materiality
              analysis in 2022 with internal and external stakeholders to
              identify the most important topics for our sustainability. The
              outcomes are 14 material topics that demonstrate high impacts on
              the long-term company success, as well as on the Environment,
              Economy and Society.
            </p>
          </div>
        </div>

        <div id="section-43663" style={{ clear: "both" }}>
          <div className="image-full-width-wrapper basic-page-paragraph-container">
            <figure>
              <div className="image-with-copyright-info--container">
                <img
                  src="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/20px/s3/2024-06/farex_Infografik_Materiality.jpg"
                  className="image-full-width-image"
                  alt=""
                  height=""
                  width=""
                  data-lazyload="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/image_full_width_0_5x/s3/2024-06/farex_Infografik_Materiality.jpg 390w, https://cdn-cf.cms.farexbus.com/drupal-assets/styles/image_full_width/s3/2024-06/farex_Infografik_Materiality.jpg 780w, https://cdn-cf.cms.farexbus.com/drupal-assets/styles/image_full_width_1_5x/s3/2024-06/farex_Infografik_Materiality.jpg 1170w"
                  sizes="100vw"
                />

                {/* <p className="image-with-copyright-info--text">© Farex</p> */}
              </div>
            </figure>
          </div>
        </div>
      </div>
    </div>
  );
};
